// An authenticator code checked by Better Auth: the second step of sign-in, the end of
// enrolment, and the step-up before an action that needs a fresh one (Security 7). Each stamps
// the session the API's staff chain reads.
import { useMutation } from "@tanstack/react-query";
import { authClient } from "@/features/auth/session";
import { m } from "@/lib/paraglide/messages.js";

export class CodeError extends Error {
  constructor(readonly reason: "invalid" | "throttled") {
    super(reason);
    this.name = "CodeError";
  }
}

export const CODE_MESSAGES = {
  invalid: m.staff_code_invalid,
  throttled: m.staff_code_throttled,
} as const;

export function useVerifyCode() {
  return useMutation({
    mutationFn: async (code: string) => {
      const { error } = await authClient.twoFactor.verifyTotp({ code });
      if (error) throw new CodeError(error.status === 429 ? "throttled" : "invalid");
    },
  });
}
